export const noDataMessageDefault = 'No data provided';
export const cancelSelectionTextDefault = 'Cancel selection';
